<template>
  <div class="verticalTabContainer">
    <PageScrolling
      hasWideBreakpoint
      :sections="pageScrollingSections"
      shouldDetectScrolling
    >
      <template
        v-if="isCloudBackupsFeatureFlagEnabled"
        v-slot:#cloudBackups
      >
        <PasswordManagerCloudBackupsSection />
      </template>
      <template v-slot:#deactivate>
        <PasswordManagerDeactivateSection />
      </template>
    </PageScrolling>
  </div>
</template>

<script>
import {
  PageScrolling,
  Types,
} from '@jumpcloud/ui-components';
import PasswordManagerCloudBackupsSection from 'client/PasswordManager/Settings/PasswordManagerCloudBackupsSection.vue';
import PasswordManagerDeactivateSection from 'client/PasswordManager/Settings/PasswordManagerDeactivateSection';

const { TabItem } = Types;

const pageScrollingSections = [
  TabItem({
    label: 'Deactivate',
    key: '#deactivate',
  }),
];

export default {
  name: 'PasswordManagerSettings',

  components: {
    PageScrolling,
    PasswordManagerCloudBackupsSection,
    PasswordManagerDeactivateSection,
  },

  computed: {
    isCloudBackupsFeatureFlagEnabled() {
      return this.$hasFeatureFlag(this.$featureFlags.passwordManagerCloudBackups);
    },

    pageScrollingSections() {
      return this.isCloudBackupsFeatureFlagEnabled
        ? [TabItem({
          label: 'Cloud Backups',
          key: '#cloudBackups',
        }), ...pageScrollingSections]
        : pageScrollingSections;
    },
  },
};
</script>

<style scoped>
.verticalTabContainer {
  height: 100%;
}
</style>
